import OpenAIPage from './Index.vue';
import SettingsWrapper from 'dashboard/routes/dashboard/settings/SettingsWrapper.vue';
import { OPENAI_PERMISSIONS } from 'dashboard/constants/permissions.js';

export const routes = [
  {
    path: 'openai',
    component: SettingsWrapper,
    meta: {
      connectionsNavigation: true,
      connectionSection: 'ai-library',
    },
    children: [
      {
        path: '',
        name: 'talkvia_openai',
        meta: {
          permissions: ['administrator', OPENAI_PERMISSIONS],
          superAdminOrPermission: true,
        },
        component: OpenAIPage,
      },
    ],
  },
];
